// Legal draft status - driven by the single backend switch in /app/backend/legal_config.py
// (served via /api/auth/signup-config). Fail-safe: treated as DRAFT until the backend says otherwise.
import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

let cached = null;
let inflight = null;

export const fetchLegalDraftStatus = () => {
  if (cached !== null) return Promise.resolve(cached);
  if (!inflight) {
    inflight = axios.get(`${API_URL}/api/auth/signup-config`)
      .then((r) => {
        cached = r.data.legal_docs_are_drafts !== false;
        return cached;
      })
      .catch(() => {
        inflight = null;
        return true;
      });
  }
  return inflight;
};

// Returns null while loading, then true (drafts) / false (published)
export const useLegalDraftStatus = () => {
  const [isDraft, setIsDraft] = useState(cached);
  useEffect(() => {
    let on = true;
    fetchLegalDraftStatus().then((v) => { if (on) setIsDraft(v); });
    return () => { on = false; };
  }, []);
  return isDraft;
};
